var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"sidebar col-md-3 col-lg-2 d-none d-md-block bg-light p-0"},[_c('div',{staticClass:"sidebar-sticky"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }